import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const http = axios.create({ baseURL: `${BACKEND_URL}/api` });

http.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("nv_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

// --- Auth ---
export const apiLogin = (email, password) =>
  http.post("/auth/login", { email, password }).then((r) => r.data);
export const apiMe = () => http.get("/auth/me").then((r) => r.data);

// --- Clinics (super admin) ---
export const listClinics = () => http.get("/clinics").then((r) => r.data);
export const createClinic = (name) => http.post("/clinics", { name }).then((r) => r.data);
export const deleteClinic = (id) => http.delete(`/clinics/${id}`).then((r) => r.data);

// --- Users ---
export const listUsers = (clinicId) =>
  http.get("/users", { params: clinicId ? { clinic_id: clinicId } : {} }).then((r) => r.data);
export const createUser = (payload) => http.post("/users", payload).then((r) => r.data);
export const deleteUser = (id) => http.delete(`/users/${id}`).then((r) => r.data);
export const resetUserPassword = (id, password) =>
  http.post(`/users/${id}/reset-password`, { password }).then((r) => r.data);

// --- Patients ---
export const listPatients = () => http.get("/patients").then((r) => r.data);
export const createPatient = (payload) => http.post("/patients", payload).then((r) => r.data);
export const updatePatient = (id, payload) => http.put(`/patients/${id}`, payload).then((r) => r.data);
export const deletePatient = (id) => http.delete(`/patients/${id}`).then((r) => r.data);
export const patientNotes = (id) => http.get(`/patients/${id}/notes`).then((r) => r.data);

// ---- Consentimiento firmado ----
// El texto viene del servidor con su hash; se devuelve tal cual al firmar para
// que quede probado qué texto exacto vio la paciente.
export const consentText = () => http.get("/consent-text").then((r) => r.data);
export const signConsent = (patientId, payload) =>
  http.post(`/patients/${patientId}/consent`, payload).then((r) => r.data);
export const revokeConsent = (patientId, payload) =>
  http.post(`/patients/${patientId}/consent/revoke`, payload).then((r) => r.data);
export const listConsents = (patientId) =>
  http.get(`/patients/${patientId}/consents`).then((r) => r.data);

// --- Appointments ---
export const listAppointments = () => http.get("/appointments").then((r) => r.data);

// --- Notes ---
export const processNote = (patientId, blob) => {
  const form = new FormData();
  form.append("patient_id", patientId);
  form.append("file", blob, "nota.webm");
  return http.post("/process-note", form, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
};
export const saveNote = (payload) => http.post("/notes", payload).then((r) => r.data);

// --- Sesión en varias notas: cada nota se guarda al momento y se resumen todas al finalizar ---
export const listFragments = (patientId) => http.get(`/patients/${patientId}/fragments`).then((r) => r.data);
export const addVoiceFragment = (patientId, blob) => {
  const form = new FormData();
  form.append("file", blob, "nota.webm");
  return http
    .post(`/patients/${patientId}/fragments`, form, { headers: { "Content-Type": "multipart/form-data" }, timeout: 120000 })
    .then((r) => r.data);
};
export const addTextFragment = (patientId, text) => {
  const form = new FormData();
  form.append("text", text);
  return http.post(`/patients/${patientId}/fragments`, form).then((r) => r.data);
};
export const updateFragment = (fragmentId, text) => http.put(`/fragments/${fragmentId}`, { text }).then((r) => r.data);
export const deleteFragment = (fragmentId) => http.delete(`/fragments/${fragmentId}`).then((r) => r.data);
export const finalizeSession = (patientId) =>
  http.post(`/patients/${patientId}/finalize`, null, { timeout: 120000 }).then((r) => r.data);
export const sendNote = (noteId) => http.post(`/notes/${noteId}/send`).then((r) => r.data);

// --- Webhook settings ---
export const getWebhookSetting = () => http.get("/settings/webhook").then((r) => r.data);
export const setWebhookSetting = (url) =>
  http.put("/settings/webhook", { n8n_webhook_url: url }).then((r) => r.data);

export const errMsg = (e, fallback = "Ha ocurrido un error") => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg || "").join(" ") || fallback;
  return fallback;
};
